<template>
  <div class="heavy-rain-gradient bg-assessment" style="height: 100vh;">
    <!-- causes error -->
    <!-- <mdb-mask overlay="green-strong" text="strong overlay" /> -->
    <NavLogo></NavLogo>

    <mdb-container style="height: 80%;" class="assessment-welcome">
      <mdb-row class="mb-4 flex-center">
        <mdb-col md="5" class="text-center">
          <mdb-card>
            <mdb-card-body>
              <h1>Let's get started</h1>
              <p>The quiz will take no more than 5 minutes to complete.</p>
              <router-link to="assessment">
                <mdb-btn color="primary" class="mt-5" rounded>Start the Quiz</mdb-btn>
              </router-link>
            </mdb-card-body>
            <mdb-card-footer></mdb-card-footer>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import firebase from "firebase";
import { store } from "../store";
import NavLogo from "../components/NavLogo";
import Footer from "../components/Footer";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
  mdbModalTitle
} from "mdbvue";

export default {
  name: "assessment-welcome",
  components: {
    NavLogo,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbModalTitle
  }
};
</script>
